<template>
  <b-container fluid class="purchase-container">
    <PurchaseFlow />
  </b-container>
</template>

<script>
import PurchaseFlow from '@/components/PurchaseFlow';
export default {
  nuxtI18n: {
    paths: {
      en: '/purchase/:id',
      de: '/kauf/:id',
      es: '/compra/:id',
      pt: '/compra/:id'
    }
  },
  components: {
    PurchaseFlow
  },
  layout: 'plain',
  async fetch({ store, route, redirect, $urlBuilder, $cookies }) {
    const plan = await store.dispatch('plans/GET_PLAN', route.params.id);
    if (plan) {
      store.dispatch('plans/OPEN_PLAN', plan);
      $cookies.set('vx.plan', plan);
    } else {
      // 302 y no 301: `GET_PLAN` tambien devuelve undefined cuando la API falla,
      // y un 301 cacheado dejaria esa URL de plan rebotando a /plans para
      // siempre en ese navegador. Es el mismo criterio que purchase-plan/_id.
      redirect(302, $urlBuilder('plans'));
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      title: this.$t('purchase.plans.seo.metaTitle', { number: this.$route.params.id }),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('purchase.plans.seo.metaDescription', { number: this.$route.params.id })
        },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ],
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style lang="scss" scoped>
.purchase-container {
  .purchase-flow-container {
    position: relative;
    background: none;
  }
  .header-container {
    height: 190px;
  }
}
</style>
